import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlanReviewRoutesService {

    returnToPlanReview: Observable<any>;
    private returnToPlanReviewSubject = new BehaviorSubject<any>("");

    constructor() {
        this.returnToPlanReview = this.returnToPlanReviewSubject.asObservable();
    }

    myMethod(data) {
        this.returnToPlanReviewSubject.next(data);
    }
}
